import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import * as Yup from "yup";
import { Formik } from "formik";
import ReactTooltip from "react-tooltip";
import { Col, Row, Input, Button, InputGroup, Label } from "reactstrap";
import { Redirect, useHistory, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCalendarAlt,
	faInfo,
	faPaperclip,
	faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import Header from "../../../../components/Header";
import { UserConsumer } from "../../../../UserContext";
import "../../ResourceLeavesInfo/SpResourceLeavesInfo.scss";
import { ViewEmployees_API } from "../ViewEmployees_API";
import { AlertPopups } from "../../../../components/AlertPopups";
import CustomReactSelect from "../../../../components/CustomReactSelect";
import { Config, Routes } from "../../../../configurations/config";
import moment from "moment";
import ImagePreviewer from "../../../../components/ImagePreviewer";

function ModifyEmployee() {
	let token = null;
	const { id } = useParams();
	const history = useHistory();
	const DatepickerRef = useRef(null);
	const [isDisabled, setIsDisable] = useState(false);
	const [imgSelected, setImgSelected] = useState(false);
	const [employeeInfo, setEmployeeInfo] = useState({
		empCode: "",
		empName: "",
		empYearsExperience: "",
		empJoinedOn: "",
		empRemarks: "",
		employeeLogin: "",
		empEmerContactAdd: "",
		empEmerContactName: "",
		empEmerContactPhone1: "",
		empEmerContactPhone2: "",
		allowLoginIfInactive: false
	});

	const validate = Yup.object().shape({
		selectedDepartment: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		selectedDevelopmentCenter: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		EmpSelectedSupervisor: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		selectedSystemRole: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		selectedDesignation: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		selectedStatus: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
	});
	const developmentCenter = [
		{ value: 1, label: "DC-1" },
		{ value: 2, label: "DC-2" },
	];
	const [attachedFileName, setAttachedFileName] = useState("");
	const [attachment, setAttachment] = useState("");
	const [fileErr, setFileErr] = useState(false);
	const [selectedDevelopmentCenter, setSelectedDevelopmentCenter] =
		useState(null);
	const [departmentList, setDepartmentList] = useState([]);
	const [selectedDepartment, setSelectedDepartment] = useState(null);
	const [supervisorList, setSupervisorList] = useState([]);
	const [selectedSupervisor, setSelectedSupervisor] = useState(null);
	const [designtaionList, setDesignationList] = useState(null);
	const [selectedDesignation, setSelectedDesignation] = useState(null);
	const [systemRoleList, setSystemRoleList] = useState([]);
	const [selectedSystemRole, setSelectedSystemRole] = useState(null);
	const [statusList, setStatusList] = useState([]);
	const [selectedStatus, setSelectedStatus] = useState(null);
	const [handleResetButton, setHandleReset] = useState(false);
	const [fileSizeErr, setFileSizeErr] = useState(false);

	useEffect(() => {
		const header = { Authorization: `Bearer ${token}` };
		if (id) {
			axios
				.get(`${ViewEmployees_API.GetEmployeeDetailById}/${id}`, {
					headers: header,
				})
				.then(({ status, data }) => {
					if (status === 200) {
						setEmployeeInfo(data);
						setAttachedFileName(data.employeeImage);
						setAttachment(data.employeeImage);

						const devCenter = developmentCenter.find(
							(x) => x.value === parseInt(data.developmentCenter)
						);
						const supervisor = supervisorList.find(
							(x) => x.value === data.empSupervisorName
						);

						setSelectedSupervisor(supervisor);
						setSelectedDevelopmentCenter(devCenter);
					}
				});
		}
	}, []);

	useEffect(() => {
		if (!handleResetButton) {
			if (!isDisabled) {
				const header = { Authorization: `Bearer ${token}` };
				axios
					.get(`${ViewEmployees_API.GetDepartmentList}`, {
						headers: header,
					})
					.then(({ status, data }) => {
						if (status === 200) {
							setDepartmentList(
								data.departments.sort((a, b) =>
									a.label.localeCompare(b.label)
								)
							);
							const department = data.departments.find(
								(x) =>
									x.value ===
									parseInt(employeeInfo.empDepartment)
							);
							setSelectedDepartment(department);
						}
					});
				axios
					.get(`${ViewEmployees_API.GetSupervisorList}`, {
						headers: header,
					})
					.then(({ status, data }) => {
						if (status === 200) {
							//converting api data according to react select value,label pair
							const allSupervisors = data.map((item) => {
								return {
									value: item.employeeId,
									label: item.name,
								};
							});
							allSupervisors.sort((a, b) =>
								a.label.localeCompare(b.label)
							);
							setSupervisorList(allSupervisors);
							setSelectedSupervisor(
								allSupervisors.find(
									(x) =>
										x.value ===
										employeeInfo.empSupervisorName
								)
							);
						}
					});
				axios
					.get(`${ViewEmployees_API.GetDesignationList}`, {
						headers: header,
					})
					.then(({ status, data }) => {
						if (status === 200) {
							setDesignationList(
								data.designations.sort((a, b) =>
									a.label.localeCompare(b.label)
								)
							);
							const designation = data.designations.find(
								(x) => x.value === employeeInfo.empDesignation
							);
							setSelectedDesignation(designation);
						}
					});
				axios
					.get(`${ViewEmployees_API.GetSystemRolesList}`, {
						headers: header,
					})
					.then(({ status, data }) => {
						if (status === 200) {
							setSystemRoleList(
								data.systemRoles.sort((a, b) =>
									a.label.localeCompare(b.label)
								)
							);
							const systemRole = data.systemRoles.find(
								(x) => x.value === employeeInfo.empRole
							);
							setSelectedSystemRole(systemRole);
						}
					});
				axios
					.get(`${ViewEmployees_API.GetEmployeeStatusList}`, {
						headers: header,
					})
					.then(({ status, data }) => {
						if (status === 200) {
							setStatusList(
								data.statuses.sort((a, b) =>
									a.label.localeCompare(b.label)
								)
							);
							const status = data.statuses.find(
								(x) => x.value === employeeInfo.empStatus
							);
							setSelectedStatus(status);
						}
					});
			}
		}
	}, [employeeInfo]);
	const handleChange = (temp, displayCode, e) => {
		setIsDisable(true);
		if (displayCode === 2) {
			//datePicker
			setEmployeeInfo({
				...employeeInfo,
				["empJoinedOn"]: temp,
			});
		}
		else if (displayCode === 3 && e?.target?.type === "checkbox") {
		// ✅ Handle checkbox
		const { name, checked } = e.target;
		setEmployeeInfo({
			...employeeInfo,
			[name]: checked,
		});
	}
		else {
			const { name, value } = temp.target;
			setEmployeeInfo({
				...employeeInfo,
				[name]: value,
			});
		}
	};
	function dataURLtoFile(dataurl) {
		let filename = employeeInfo.empName + ".png";
		let arr = dataurl.split(","),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);

		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}

		return new File([u8arr], filename, { type: mime });
	}
	const handleSubmit = () => {
		let formdata = new FormData();
		formdata.append(
			"empDepartment",
			selectedDepartment ? selectedDepartment.value : null
		);
		formdata.append(
			"empDesignation",
			selectedDesignation ? selectedDesignation.value : null
		);
		formdata.append(
			"empSupervisorName",
			selectedSupervisor ? selectedSupervisor.value : null
		);
		formdata.append(
			"empRole",
			selectedSystemRole ? selectedSystemRole.value : null
		);
		formdata.append(
			"empStatus",
			selectedStatus ? selectedStatus.value : null
		);
		formdata.append(
			"developmentCenter",
			selectedDevelopmentCenter ? selectedDevelopmentCenter.value : null
		);
		formdata.append("employeeLogin", employeeInfo.employeeLogin);

		if (employeeInfo.empEmerContactAdd)
			formdata.append(
				"empEmerContactAdd",
				employeeInfo.empEmerContactAdd
			);
		if (employeeInfo.empEmerContactName)
			formdata.append(
				"empEmerContactName",
				employeeInfo.empEmerContactName
			);
		if (employeeInfo.empRemarks)
			formdata.append("empRemarks", employeeInfo.empRemarks);
		if (employeeInfo.empEmerContactPhone1)
			formdata.append(
				"empEmerContactPhone1",
				employeeInfo.empEmerContactPhone1
			);
		if (employeeInfo.empEmerContactPhone2)
			formdata.append(
				"empEmerContactPhone2",
				employeeInfo.empEmerContactPhone2
			);
		if (employeeInfo.empYearsExperience)
			formdata.append(
				"empYearsExperience",
				employeeInfo.empYearsExperience
			);
		if (employeeInfo.empJoinedOn) {
			formdata.append(
				"empJoinedOn",
				moment(employeeInfo.empJoinedOn).format("YYYY-MM-DD")
			);
		}
formdata.append("allowLoginIfInactive",employeeInfo.allowLoginIfInactive
			);
		if (attachment !== null) {
			if (imgSelected) {
				formdata.append("UpdatedImage", true);
				formdata.append("employeeImage", dataURLtoFile(attachment));
			} else formdata.append("UpdatedImage", false);
		} else {
			if (!imgSelected) {
				formdata.append("UpdatedImage", true);
				formdata.append("employeeImage", null);
			}
		}

		if (!fileErr && !fileSizeErr)
			axios
				.put(
					`${ViewEmployees_API.UpdateEmployeeInfo}/${id}`,
					formdata,
					{
						headers: {
							"Content-Type": "multipart/form-data",
							Authorization: `Bearer ${token}`,
						},
					}
				)
				.then(({ status }) => {
					if (status === 200) {
						AlertPopups.successAlert.fire({
							text: "Employee Info Updated",
						});
						history.push(Routes.ViewEmployees);
					} else {
						AlertPopups.ErrorAlert.fire({
							text: "Employee Info Updation Error",
						});
					}
				})
				.catch((error) => {
					if (error.response)
						AlertPopups.ErrorAlert.fire({
							text: error.response.data.message,
						});
				});
	};

	const handleReset = () => {
		setHandleReset(true);
		setEmployeeInfo({
			empCode: employeeInfo.empCode,
			empName: employeeInfo.empName,
			empYearsExperience: "",
			empJoinedOn: "",
			empRemarks: "",
			employeeLogin: "",
			empEmerContactAdd: "",
			empEmerContactName: "",
			empEmerContactPhone1: "",
			empEmerContactPhone2: "",
			allowLoginIfInactive:employeeInfo.allowLoginIfInactive,
		});
		setSelectedSupervisor(null);
		setSelectedDepartment(null);
		setSelectedDevelopmentCenter(null);
		setSelectedSystemRole(null);
		setSelectedStatus(null);
		setSelectedDesignation(null);
		handleRemoveAttachement();
	};
	const formatBytes = (a) => {
		let units = ["B", "KB", "MB", "GB", "TB"],
			bytes = a,
			i;

		for (i = 0; bytes >= 1024 && i < 4; i++) {
			bytes /= 1024;
		}

		return { size: bytes.toFixed(2), units: units[i] };
	};

	const handleAddAttachement = (temp) => {
		if (temp.target.files[0] !== undefined) {
			setFileErr(false);
			setFileSizeErr(false);

			let totalBytes = temp.target.files[0].size;
			let fileInfo = formatBytes(totalBytes);
			if (fileInfo.units === "MB")
				if (parseInt(fileInfo.size) > 1) setFileSizeErr(true);

			if (["image/png"].includes(temp.target.files[0].type)) {
				const reader = new FileReader();
				let img = "";
				setImgSelected(true);
				if (reader.result)
					reader.addEventListener("load", () => {
						const uploaded_image = reader.result;
						img =
							document.getElementsByClassName("profileThumnail");
						img.src = uploaded_image;
					});
				else {
					let reader2 = new FileReader();

					reader2.onload = function (e) {
						const uploaded_image = reader2.result;
						img =
							document.getElementsByClassName("profileThumnail");
						img.src = uploaded_image;
						const img2 =
							document.getElementById(
								"imgPrview"
							).lastElementChild;
						img2.src = uploaded_image;
						setAttachment(uploaded_image);
					};

					reader2.readAsDataURL(temp.target.files[0]);
				}
			} else {
				setFileErr(true);
			}
		}
	};
	const handleRemoveAttachement = () => {
		setImgSelected(false);
		document.getElementById("attachment").value = null;
		setFileErr(false);
		setFileSizeErr(false);
		setAttachment(null);
		setAttachedFileName("");

		if (document.getElementById("icon")) {
			document.getElementById("icon").remove();
		}
	};
	const openDatepicker = () => {
		const datepickerElement = DatepickerRef.current;
		datepickerElement.setFocus(true);
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.empRole.includes("3") ||
					userDetails.designation.toString() === "4" ||
					userDetails.id.toString() === "180" ||
					userDetails.id.toString() === "269" ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Modify Employee"
								headerBorder="false"
								navigateBack={() =>
									history.push(Routes.ViewEmployees)
								}
							/>

							{employeeInfo && (
								<Formik
									enableReinitialize={true}
									initialValues={{
										selectedDepartment: selectedDepartment,
										selectedSystemRole: selectedSystemRole,
										EmpSelectedSupervisor:
											selectedSupervisor,
										selectedDesignation:
											selectedDesignation,
										selectedDevelopmentCenter:
											selectedDevelopmentCenter,
										selectedStatus: selectedStatus,
										empJoinedOn: employeeInfo.empJoinedOn,
										empRemarks: employeeInfo.empRemarks,
										empEmerContactName:
											employeeInfo.empEmerContactName,
										empYearsExperience:
											employeeInfo.empYearsExperience,
										empEmerContactPhone1:
											employeeInfo.empEmerContactPhone1,
										empEmerContactPhone2:
											employeeInfo.empEmerContactPhone2,
										empEmerContactAdd:
											employeeInfo.empEmerContactAdd,
									}}
									validationSchema={validate}
									validateOnChange={true}
									onSubmit={() => {
										handleSubmit();
									}}
								>
									{({ errors, handleSubmit }) => (
										<form onSubmit={handleSubmit}>
											<>
												<div className="formInfoContainer my-3">
													<div className="formInfoContainerHeader ">
														<Label sm={12}>
															Employee Information
														</Label>
													</div>

													<Col>
														<Row className="py-2 px-2">
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Employee
																		Name
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<p className="formValueContainer">
																	{
																		employeeInfo.empName
																	}
																</p>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Employee
																		Code
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<p className="formValueContainer">
																	{
																		employeeInfo.empCode
																	}
																</p>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Department
																		<span className="required">
																			*
																		</span>
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<CustomReactSelect
																	name="empDepartment"
																	options={
																		departmentList
																	}
																	value={
																		selectedDepartment
																	}
																	onChange={(
																		value
																	) =>
																		setSelectedDepartment(
																			value
																		)
																	}
																	className={`ml-0 ${
																		errors.selectedDepartment
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Development
																		Center
																		<span className="required">
																			*
																		</span>
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<CustomReactSelect
																	name="empDevelopmentCenter"
																	options={
																		developmentCenter
																	}
																	value={
																		selectedDevelopmentCenter
																	}
																	onChange={(
																		value
																	) =>
																		setSelectedDevelopmentCenter(
																			value
																		)
																	}
																	className={`ml-0 ${
																		errors.selectedDevelopmentCenter
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		System
																		Role
																		<span className="required">
																			*
																		</span>
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<CustomReactSelect
																	name="empRole"
																	options={
																		systemRoleList
																	}
																	value={
																		selectedSystemRole
																	}
																	onChange={(
																		value
																	) =>
																		setSelectedSystemRole(
																			value
																		)
																	}
																	className={`ml-0 ${
																		errors.selectedSystemRole
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Supervisor
																		Name
																		<span className="required">
																			*
																		</span>
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<CustomReactSelect
																	name="empSupervisorName"
																	options={
																		supervisorList
																	}
																	value={
																		selectedSupervisor
																	}
																	onChange={(
																		value
																	) =>
																		setSelectedSupervisor(
																			value
																		)
																	}
																	className={`ml-0 ${
																		errors.EmpSelectedSupervisor
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Designation
																		<span className="required">
																			*
																		</span>
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<CustomReactSelect
																	name="empDesignation"
																	options={
																		designtaionList
																	}
																	value={
																		selectedDesignation
																	}
																	onChange={(
																		value
																	) =>
																		setSelectedDesignation(
																			value
																		)
																	}
																	className={`ml-0 ${
																		errors.selectedDesignation
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Experience
																		(in
																		Years)
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<Input
																	type="number"
																	name="empYearsExperience"
																	value={
																		employeeInfo.empYearsExperience
																	}
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			3,
																			event
																		)
																	}
																	className={`supDesciptionBox mt-2 ${
																		errors.empYearsExperience
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Joining
																		Date
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1 datepicker-wrapper"
															>
																<InputGroup className="datepicker-wrapper">
																	<DatePicker
																		showYearDropdown
																		showMonthDropdown
																		dateFormatCalendar=" " //for title
																		dateFormat="dd/MM/yyyy"
																		name="empJoinedOn"
																		className="custom-container"
																		selected={
																			employeeInfo.empJoinedOn
																				? new Date(
																						employeeInfo.empJoinedOn
																				  )
																				: null
																		}
																		onChange={(
																			value,
																			event
																		) =>
																			handleChange(
																				value,
																				2,
																				event
																			)
																		}
																		onChangeRaw={(
																			e
																		) => {
																			e.preventDefault();
																		}}
																		autoComplete="off"
																		ref={
																			DatepickerRef
																		}
																	/>

																	<FontAwesomeIcon
																		icon={
																			faCalendarAlt
																		}
																		className="calender-icon"
																		color="keppel"
																		onClick={() =>
																			openDatepicker()
																		}
																	/>
																</InputGroup>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Employee
																		Status
																		<span className="required">
																			*
																		</span>
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<CustomReactSelect
																	name="empStatus"
																	options={
																		statusList
																	}
																	value={
																		selectedStatus
																	}
																	onChange={(
																		value
																	) =>
																		setSelectedStatus(
																			value
																		)
																	}
																	className={`ml-0 ${
																		errors.selectedStatus
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>

															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Employee
																		Login
																		<span className="required">
																			*
																		</span>
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<Input
																	type="text"
																	name="employeeLogin"
																	value={
																		employeeInfo.employeeLogin
																	}
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			3,
																			event
																		)
																	}
																	className={`supDesciptionBox`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Remarks
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<Input
																	type="textarea"
																	name="empRemarks"
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			4,
																			event
																		)
																	}
																	value={
																		employeeInfo.empRemarks
																	}
																	className={`supDesciptionBox`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div className="d-flex">
																		<span>
																			Profile
																			Image
																		</span>
																		<span
																			className="imp-info mt-1"
																			data-tip="tooltip"
																			data-for="imageInfo"
																		>
																			<FontAwesomeIcon
																				icon={
																					faInfo
																				}
																				className="fas fa-info-circle infoExclamation-icon"
																			/>
																		</span>
																		<ReactTooltip
																			id="imageInfo"
																			className="ImageInfoToolTip"
																			place="bottom"
																			effect="solid"
																			variant="light"
																			positionStrategy="fixed"
																		>
																			{"*Image size should be less than 1 MB\n" +
																				"*Dimensions should be = 200 x 200 \n" +
																				"*Only .png image is allowed"}
																		</ReactTooltip>
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																{attachedFileName ? (
																	<>
																		<Row
																			style={{
																				marginLeft:
																					"10px",
																			}}
																		>
																			<ImagePreviewer
																				src={`${
																					Config.server_url
																				}/${attachedFileName}?t=${new Date().getTime()}`}
																			/>

																			<Input
																				name="attachment"
																				id="attachment"
																				type="file"
																				className="d-none"
																				readOnly={
																					true
																				}
																				onChange={(
																					value
																				) =>
																					handleAddAttachement(
																						value
																					)
																				}
																			/>
																			<Col className="d-flex flex-direction-row align-items-center">
																				<FontAwesomeIcon
																					icon={
																						faPaperclip
																					}
																					size="1x"
																					color="black"
																					className="attIcon"
																					style={{
																						marginRight:
																							"2px",
																					}}
																				/>
																				<a
																					href={`${
																						Config.server_url
																					}/${attachedFileName}?t=${new Date().getTime()}`}
																					target="_blank"
																					rel="noopener noreferrer"
																					id="attLink"
																					className="link"
																					style={{
																						textDecoration:
																							"underline",
																						fontWeight:
																							"normal",
																					}}
																				>
																					{attachedFileName.substring(
																						17,
																						30
																					)}
																				</a>
																				<span
																					onClick={() =>
																						document
																							.getElementById(
																								"attachedFile"
																							)
																							.click()
																					}
																				/>
																			</Col>
																			<Col className="d-flex align-items-center justify-content-end mx-0">
																				<FontAwesomeIcon
																					icon={
																						faWindowClose
																					}
																					className="att-remove-icon"
																					color="keppel"
																					onClick={() =>
																						handleRemoveAttachement()
																					}
																					hidden={
																						!attachment
																					}
																				/>
																			</Col>
																		</Row>
																	</>
																) : (
																	<>
																		<Col className="d-flex flex-direction-row px-0 align-items-center">
																			<ImagePreviewer
																				src={
																					attachment
																				}
																			/>
																			<Input
																				type="file"
																				name="attachment"
																				id="attachment"
																				accept="image/png"
																				onChange={(
																					value
																				) =>
																					handleAddAttachement(
																						value
																					)
																				}
																				style={{
																					marginLeft:
																						"20px",
																				}}
																				className="overflow-hidden"
																			/>
																			<span>
																				<FontAwesomeIcon
																					icon={
																						faWindowClose
																					}
																					className="att-remove-icon"
																					color="keppel"
																					onClick={() =>
																						handleRemoveAttachement()
																					}
																					hidden={
																						!attachment
																					}
																				/>
																			</span>
																		</Col>
																	</>
																)}
																
	
																{fileErr && (
																	<div className="input-feedback">
																		Only
																		".png"
																		type
																		files
																		allowed
																	</div>
																)}
																{fileSizeErr && (
																	<div className="input-feedback">
																		Image
																		Size
																		should
																		be less
																		than 1
																		MB
																	</div>
																)}
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Allow Login If Inactive
																	</div>
																</div>
															</Col>
															<Col
																md={3}
																lg={4}
																className="my-1"
															>
																<Input
															style={{ marginLeft: 0 }}
																type="checkbox"
																id="allowLoginIfInactive"
																name="allowLoginIfInactive"
																checked={employeeInfo.allowLoginIfInactive || false}
																onChange={(e) =>
																	handleChange(e.target.checked, 3, e)
																}
																className={`ml-2 checkboxInput form-check-input` }
															/>
															</Col>
														</Row>
													</Col>
												</div>
												<div className="formInfoContainer">
													<div className="formInfoContainerHeader">
														<Label sm={12}>
															Emergency Contact
														</Label>
													</div>
													<Col>
														<Row className="py-2 px-2">
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Person
																		Name
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<Input
																	type="text"
																	name="empEmerContactName"
																	value={
																		employeeInfo.empEmerContactName
																	}
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			3,
																			event
																		)
																	}
																	className={`supDesciptionBox ${
																		errors.empEmerContactName
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Phone 1
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<Input
																	type="text"
																	name="empEmerContactPhone1"
																	value={employeeInfo.empEmerContactPhone1?.replace(
																		/[^0-9+]/gi,
																		""
																	)}
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			3,
																			event
																		)
																	}
																	className={`supDesciptionBox ${
																		errors.empEmerContactPhone1
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Phone 2
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<Input
																	type="text"
																	name="empEmerContactPhone2"
																	value={employeeInfo.empEmerContactPhone2?.replace(
																		/[^0-9+]/gi,
																		""
																	)}
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			3,
																			event
																		)
																	}
																	className={`supDesciptionBox ${
																		errors.empEmerContactPhone2
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
															<Col md={3} lg={2}>
																<div className="formDetailHeader">
																	<div>
																		Address
																	</div>
																</div>
															</Col>
															<Col md={3} lg={4}>
																<Input
																	type="textarea"
																	maxLength="400"
																	name="empEmerContactAdd"
																	value={
																		employeeInfo.empEmerContactAdd
																	}
																	onChange={(
																		value,
																		event
																	) =>
																		handleChange(
																			value,
																			3,
																			event
																		)
																	}
																	className={`supDesciptionBox ${
																		errors.empEmerContactAdd
																			? "h-auto invalid"
																			: "h-auto"
																	}`}
																/>
															</Col>
														</Row>
													</Col>
												</div>
												<div className="btns">
													<Button
														type="submit"
														className="submit-btn leftBtn"
													>
														Update
													</Button>

													<Button
														className="reset-btn"
														onClick={handleReset}
													>
														Reset
													</Button>
												</div>
											</>
										</form>
									)}
								</Formik>
							)}
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default ModifyEmployee;
